import React, { useState, useEffect } from "react";
import PrintIcon from "@mui/icons-material/Print";
import { useNavigate } from "react-router-dom";

const AdminPrintNeedConfirmedOrderiInfo = (props) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table-icon">
        <PrintIcon
          onClick={() =>
            navigate(
              `/print-need-confirmed-provider-order-report-details/${props.selectedRow?.id}`
            )
          }
        />
      </div>
    </>
  );
};

export default AdminPrintNeedConfirmedOrderiInfo;
